module.exports = __webpack_public_path__ + "assets/img/favicon-16x16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon-16x16.png
// module id = 1928
// module chunks = 0